/* 
  JS Coding conventions:
    Before adding new JS, check assets/dawn-js-guide.js
    Focus on liquid over JavaScript (with exceptions on excessive complexity)
    For large JS functions that aren't needed on page load, load them from a separate file as a module
    If a componenet uses a function in this file, add comment:
    {% comment %} fostr - uses: assets/wc-global.js/wcClassToggle {% endcomment %} 

  Naming conventions:
    Append 'wc' to core functions and brand initals for brand-specific JS
    inner funtions:
      - when called inside function to handle something: handleSomething ()
      - when triggered by an event: onSomeevent ()

  Web-components:
    wcClassToggle - allows an element to toggle a class on itself or another element
    wcAccordion - creates an accordion that keeps one item open

  Functions:
    wcIsVisible - adds a class to the body tag when an element is visible
*/

// <wc-class-toggle data-toggle-class="active" toggleElement="#menu">...</wc-class-toggle>
// <wc-class-toggle></wc-class-toggle> (defaults to itself and 'active')
class wcClassToggle extends HTMLElement {
  constructor() {
    super();
    this.onclick = () => {
      const toggleElement = this.dataset.toggleElement ? document.querySelector(this.dataset.toggleElement) : this;
      const toggleClass = this.dataset.toggleClass || 'active';
      toggleElement.classList.toggle(toggleClass);
    }
  }
}
window.customElements.define('wc-class-toggle', wcClassToggle);

// <wc-accordion></wc-accordion>
class wcAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordions = this.querySelectorAll('[data-wc-accordion]');
    this.watchTriggers();
  }
  watchTriggers() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-wc-accordion-trigger]')) {
        this.accordions.forEach(accordion => {
          if (accordion === event.target.closest('[data-wc-accordion]')) {
            accordion.classList.toggle('active');
          } else {
            accordion.classList.remove('active');
          }
        })
      }
    });
  }
}
window.customElements.define('wc-accordion', wcAccordion);

// <div data-is-visible="my-div">...</div>
window.addEventListener('load', () => {
  const wcIsVisible = (element, className) => {
    const isVisibleObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.body.classList.add(className);
        } else {
          document.body.classList.remove(className);
        }
      });
    });
    isVisibleObserver.observe(element);
  }
  document.querySelectorAll('[data-is-visible]').forEach(element => {
    wcIsVisible(element, `is-visible--${element.dataset.isVisible}`);
  });
});